module.exports = __webpack_public_path__ + "static/media/circulo_D87748.663d50fa.svg";